module.exports = __webpack_public_path__ + "img/DSC_0322.NEF.45a32ab2.jpg";